export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
        <p className="text-zinc-400 mb-8">Last updated: March 24, 2026</p>

        <div className="space-y-8 text-zinc-300">
          <section>
            <h2 className="text-xl font-semibold text-zinc-100 mb-3">What We Collect</h2>
            <p>
              When you use our writing tools, we collect and store the content you create,
              including documents, notes, and conversation history. We also collect your
              email address for authentication purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-zinc-100 mb-3">How We Use Your Data</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>To provide the AI writing assistance you request</li>
              <li>To save your work so you can access it later</li>
              <li>To authenticate you and protect your account</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-zinc-100 mb-3">AI Processing</h2>
            <p>
              Your content is sent to AI providers (Anthropic Claude) for processing when
              you use our editing and writing features. This is necessary to provide the
              service. We do not use your content to train AI models.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-zinc-100 mb-3">Data Access</h2>
            <p>
              Your data is stored securely with encryption at rest. We do not access,
              read, or review your content unless:
            </p>
            <ul className="list-disc list-inside space-y-2 mt-2">
              <li>You explicitly request support and share content with us</li>
              <li>Required by law or valid legal process</li>
              <li>Necessary to investigate security incidents</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-zinc-100 mb-3">Data Security</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>All data is encrypted at rest</li>
              <li>Row-level security ensures users can only access their own data</li>
              <li>All connections use HTTPS encryption</li>
              <li>Authentication is handled via secure token-based sessions</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-zinc-100 mb-3">Data Retention</h2>
            <p>
              We retain your data for as long as your account is active. You can delete
              your sessions and content at any time. Account deletion removes all
              associated data.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-zinc-100 mb-3">Your Rights</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Access your data through the application</li>
              <li>Delete your sessions and content</li>
              <li>Request account deletion</li>
              <li>Export your content</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-zinc-100 mb-3">Contact</h2>
            <p>
              For privacy questions or data requests, contact us at{' '}
              <a href="mailto:privacy@yourdomain.com" className="text-blue-400 hover:underline">
                privacy@yourdomain.com
              </a>
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-zinc-800">
          <a href="/" className="text-blue-400 hover:underline">
            &larr; Back to app
          </a>
        </div>
      </div>
    </div>
  )
}
